import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Services from "@/pages/Services";

export const Route = createFileRoute("/zh-cn/services/")({
  head: () => buildRouteHead("/zh-cn/services"),
  component: Services,
});

